var TagalysCustomisationsCollection = TagalysCustomisationsCollection || {};
var plp_params = {
  collectionId: window.plp_vars.plp_id,
};
var plp_selector = "[data-widget=product-listing-page-container]";
var Firstfilter = 0;


const plpSearchThreshold = window.theme.gtmSearchThreshold || 2;
const plpSearchDelay = window.theme.gtmSearchDelayMS || 1200;
let viewPLPDataLayerDelay;
let viewPLPItemListDataLayerDelay;
let clickPLPSortOptionDataLayerDelay;

const viewPLPDataLayerEvent = (helpers, productCardSelector) => {
  if (viewPLPDataLayerDelay) {
    clearTimeout(viewPLPDataLayerDelay);
  }

  const { getRequestParams, getAPIResponse } = helpers;
  const count = getAPIResponse().total || getAPIResponse().products.length;
  const requestParams = getRequestParams();
  const viewFilterEvent = () => {
    var appliedFilters = helpers.getAppliedFilters(true);
    theme.PLPDataLayerEvents.trackEvent(appliedFilters, 'filter', requestParams);
  }

  const viewItemListEvent = (skusComingIntoView = []) => {
    const viewItemListPLPEvent = (itemList = []) => {
      if (!itemList.length) {
        return;
      }
      if (viewPLPItemListDataLayerDelay) {
        clearTimeout(viewPLPItemListDataLayerDelay);
      }

      viewPLPItemListDataLayerDelay = setTimeout(() => {
        let promotionEvent = JSON.parse(
          localStorage.getItem("ga4-promotionView") || "{}"
        );
        const menuNavigationAction = JSON.parse(
          localStorage.getItem("ga4-navigationClick") || "{}"
        );
        const menuNavigationState =
          menuNavigationAction.menu_navigation_state || {};
        const isSearchSuggestions = productCardSelector.includes(
          "product-suggestions"
        );
        let visibleCount = window.viewItemListPLP.length;
        if (isSearchSuggestions && visibleCount > 5) {
          visibleCount = 5;
        }
        theme.PLPDataLayerEvents.setPLPDataLayerEvent({
          event: "view_item_list",
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEvent, {
            items: itemList,
            item_list_id: plp.item_list_id,
            item_list_name: plp.item_list_name,
            item_list_type: plp.item_list_type,
            item_total_count: count,
            item_visible_count: visibleCount,
          }),
        }, 'ecommerce');
        skusComingIntoView = [];
      }, 1000);
    };

    let productCards = document.querySelectorAll(productCardSelector);
    if (productCards.length) {
      productCards.forEach((card) => {
        let isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
        card.setAttribute("data-visible-by-default", isVisibleNow);
        if (isVisibleNow) {
          skusComingIntoView.push(card.getAttribute("data-sku"));
        }

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            const visibleByDefault =
              card.getAttribute("data-visible-by-default") || false;
            isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
            if (entry.intersectionRatio > 0) {
              observer.unobserve(entry.target);

              card.setAttribute("data-visible-in-viewport", isVisibleNow);
              if (isVisibleNow) {
                const allResults = getAPIResponse().products;
                skusComingIntoView.push(card.getAttribute("data-sku"));
                const itemsInViewport = allResults.filter((item) =>
                  skusComingIntoView.includes(item.variants[0].sku)
                );
                window.viewItemListPLP = window.viewItemListPLP || [];
                const items = itemsInViewport.map((item) => {
                  const itemExists = window.viewItemListPLP.find(
                    (listItem) => listItem.item_id === item.variants[0].sku
                  );
                  const index = allResults.findIndex(
                    (result) => result.variants[0].sku === item.variants[0].sku
                  );
                  const productType = item.product_type;
                  const newItem = {
                    index: index + 1,
                    item_id: item.variants[0].sku,
                    item_name: item.title.replace(/["']/g, ""),
                    item_brand: "Lovisa",
                    item_category: productType,
                    item_list_id: plp.item_list_id,
                    item_list_name: plp.item_list_name,
                    price: item.price,
                    quantity: 1,
                    visible_by_default: visibleByDefault,
                  };
                  if (!itemExists) {
                    window.viewItemListPLP.push(newItem);
                  }

                  if (card.getAttribute("data-sku") === item.variants[0].sku) {
                    card.addEventListener("click", () => {
                      // DATALAYER push data
                      let promotionEvent = JSON.parse(
                        localStorage.getItem("ga4-promotionView") || "{}"
                      );
                      const menuNavigationAction = JSON.parse(
                        localStorage.getItem("ga4-navigationClick") || "{}"
                      );
                      const menuNavigationState =
                        menuNavigationAction.menu_navigation_state || {};

                      const eventData = {
                        event: "select_item",
                        menu_navigation_state: menuNavigationState,
                        ecommerce: Object.assign(promotionEvent, {
                          item_list_id: plp.item_list_id,
                          item_list_name: plp.item_list_name,
                          item_list_type: plp.item_list_type,
                          items:  [newItem],
                        }),
                      }

                      window.pushEvent(eventData, 'ecommerce');
                      theme.PLPDataLayerEvents.setPLPDataLayerEvent(eventData, 'ecommerce');
                    });
                  }
                  return newItem;
                });
                viewItemListPLPEvent(items);
              }
            }
          });
        };
        const observer = new IntersectionObserver(handleIntersection);
        observer.observe(card);
      });
    }
  };
  viewPLPDataLayerDelay = setTimeout(() => {
    viewFilterEvent();
    viewItemListEvent();
  }, plpSearchDelay);
};

// inline ad functions read the metaobject info and display the inline ad

/**
 * Checks if an inline ad is currently active based on the provided timestamps.
 *
 * @param {Object} inputTimestamp - An object containing date_from and optionally date_to timestamps.
 * @param {number} inputTimestamp.date_from - The start timestamp in seconds.
 * @param {number} [inputTimestamp.date_to] - The optional end timestamp in seconds.
 * @returns {boolean} - Returns true if the current date is within the range specified by date_from and date_to, otherwise false.
 */
const isActiveInlineAd = (inputTimestamp) => {
  const currentDate = new Date();
  const start = new Date(inputTimestamp.date_from * 1000);

  // check if the input date has date_to and compare with the current date if current date is less than the date_to then return true
  if (inputTimestamp.date_to) {
    const end = new Date(inputTimestamp.date_to * 1000);
    return currentDate > start && currentDate < end;
  } else {
    return currentDate > start;

  }

};

/**
 * set default current language to 'en'
 *
 * @type {string}
 * */
let currentLang = 'en';


/**
 * filter the metaobject array to get the unique position
 * if the position is same then filter the metaobject based on the date_from
 *
 * @param {Array} metaObjArrayInput - An array of metaobjects
 * @returns {Array} - Returns an array of unique metaobjects based on position and date_from
 * */

const filterSamePosition = (metaObjArrayInput) => {
  // Step 1: Sort the array by position and then by date_from in descending order
  metaObjArrayInput.sort((a, b) => {
    if (a.position === b.position) {
      return b.date_from - a.date_from; // Newest date_from first
    }
    return a.position - b.position; // Ascending order of position
  });

  // Step 2: Filter unique positions
  const uniquePositions = new Map();
  const filteredArray = metaObjArrayInput.filter(item => {
    if (!uniquePositions.has(item.position)) {
      uniquePositions.set(item.position, true);
      return true;
    }
    return false;
  });

  return filteredArray;

}
/**
 * filter the close position metaobject array to make sure the ad is not come close to each other
 * if the position is close to each other then filter will keep the posistions have one space between them
 *  @param {Array} metaObjArrayInput - An array of metaobjects
 *  @returns {Array} - Returns an array of metaobjects with positions that are not close to each other
 * * */
const filterClosePositions = (metaObjArrayInput, threshold = 1) => {
  // Step 1: Sort the array by position in ascending order
  metaObjArrayInput.sort((a, b) => a.position - b.position);

  // Step 2: Filter close positions
  const filteredArray = [];
  let lastPosition = null;

  for (let i = 0; i < metaObjArrayInput.length; i++) {
    const currentItem = metaObjArrayInput[i];

    // If lastPosition is null or the difference between current and last position is greater than the threshold
    if (lastPosition === null || currentItem.position - lastPosition > threshold) {
      filteredArray.push(currentItem);
      lastPosition = currentItem.position;

    }
  }

  return filteredArray;

};
/**
 * filter the metaobject array to get the valid metaobjects for the current collection
 * if the collection is not empty then filter the metaobject based on the collection
 * if the exclusion_collection is not empty then filter the metaobject based on the exclusion_collection
 * @param {Array} omniInlineAdObjArray - An array of metaobjects will show on all collection except the collection in exclusion_collection
 * @param {Array} plpInlineAdObjArray - An array of metaobjects will only show on the collection in collection property
 * @returns {Array} - Returns an array of metaobjects valid for the current collection
 * */

const filterForCurrentCollection = (omniInlineAdObjArray, plpInlineAdObjArray) => {
  // filter metaobjects valid for the current collection
  const plpIncludeOmniObjItem = (plpObjItem) => {
    if (plpObjItem.collection && plpObjItem.collection.length) {
      const collectionIdArray = plpObjItem.collection.map((item) => {
        const parts = item.split('/');
        const lastPart = parts.pop();
        const id_result = Number(lastPart);
        return id_result;

      });
      return collectionIdArray.includes(window.theme.collectionId);
    } else {
      return false;
    }
  };



  const checkExclusionOmniObjItem = (omniObjItem) => {
    if (omniObjItem.exclusion_collection && omniObjItem.exclusion_collection.length) {
      const collectionIdArray = omniObjItem.exclusion_collection.map((item) => {
        const parts = item.split('/');
        const lastPart = parts.pop();
        const id_result = Number(lastPart);
        return id_result;
      });

      return !collectionIdArray.includes(window.theme.collectionId);
    } else {
      return true;
    }
  };

  // Function to filter omniInlineAdObjArray based on the given conditions
  const filterOmniInlineAdObjArray = (inputArray, type) => {
    const collectionType = type === 'exclude' ? true : false;
    if (inputArray && inputArray.length && window.theme.collectionId) {
      const filteredArray = collectionType ? inputArray.filter(checkExclusionOmniObjItem) : inputArray.filter(plpIncludeOmniObjItem);
      return filteredArray;
    } else {
      return [];
    }
  };



  const filteredOnmiArray = filterOmniInlineAdObjArray(omniInlineAdObjArray, 'exclude');
  const filteredPlpArray = filterOmniInlineAdObjArray(plpInlineAdObjArray, 'include');

  const mergedArray = filteredOnmiArray.concat(filteredPlpArray);

  return mergedArray;
};


const inline_ad_metaobject = window.theme.omniInlineAdMetaobjects;

const omni_plp_inline_ad_array = window.theme.omniInlineAdMetaobjects ? JSON.parse(window.theme.omniInlineAdMetaobjects) : [];
const plp_inline_ad_array = window.theme.plpInlineAdMetaobjects ? JSON.parse(window.theme.plpInlineAdMetaobjects) : [];
const array_after_filter = filterForCurrentCollection(omni_plp_inline_ad_array, plp_inline_ad_array);

const removeSamePositionAds = filterSamePosition(array_after_filter);
const removeClosePositionAds = filterClosePositions(removeSamePositionAds, 1);

const calculateInsertionIndices = (positionArray) => {
  // Extract positions and items from positionArray
  // Sort positions and corresponding items
  const sortedIndices = positionArray.sort((a, b) => a.position - b.position);

  const insertIndexArray = sortedIndices.map((item, index) => {
      const indexOfPosition = item.position - 1;
      const resultIndex = indexOfPosition - index;
      return { resultIndex: resultIndex, item: item };
  }
  );

  return insertIndexArray.reduce((acc, item) => {
    acc[item.resultIndex] = item.item.position;
    return acc;
  }, {})
}
// the object will have the index as the key and the position as the value for the insertion the ad in this collection.
const mappingIndexObj = calculateInsertionIndices(removeClosePositionAds);


var promo_multibuy = 0;
var productListingPageTemplates = {
  widget: {
    labels: getTagalysLabels(),
    options: {
      includeTagalysCSS: false,
      canAppendQueryStringToUrl: true,
      perPage: window.plp_vars.plp_limit,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      if (helpers.isInitialLoading()) {
        return html`<${args.templates.loader} />`;
      }

      var classes = ["plp", "search-results", "results-tagalys", "page-width"];
      if (helpers.isFilterDrawerOpen()) {
        classes.push("filter-drawer-opened");
      }

      if (helpers.isLoading()) {
        classes.push("loading");
      }

      if (helpers.canShowFiltersInDrawer()) {
        classes.push("show-filters-in-drawer");
      }

      var className = classes.join(" ");

      var plp_limit = window.plp_vars.plp_limit;
      var totalpagecount = helpers.getCurrentPage() * plp_limit;
      if (totalpagecount > helpers.getTotalProductsCount()) {
        totalpagecount = helpers.getTotalProductsCount();
      }
      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction = appliedFilters.length;
      let previousPageLoad = '';
      if (helpers.canLoadPreviousResults() == true && helpers.getCurrentPage() > 1) {
        previousPageLoad = html`<${args.templates.loadPrevious} />`;
      }
      let viewType = localStorage.getItem("collectionViewType") || "view-4";
      collectionFiltersSticky();

      return html`
              <div class=${className}>
                <${args.templates.header} />
                  <div class="grid grid__uniform collection__container">
                    <div class="grid__item collection-sorting">
                      <div class="filter-main">
                        <div class="hide-filter">
                          ${window.tagalysIcon.hideFilter(html)}
                          <span>Hide Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                        </div>
                        <div class="show-filter" style="display:none;">
                          ${window.tagalysIcon.showFilter(html)}
                          <span>Show Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                        </div>
                      </div>

                      <div class="collection__filters">
                        <div class="collection__filter-wrap ">
                          <div class="collection-sort-block">
                            <${args.templates.productListHeader} />
                          </div>
                          <div class="viewing-main">
                               <button class="viewing-type viewing-type-3 ${viewType == 'view-3' ? 'active' : ''}">
                                ${window.tagalysIcon.view3(html)}
                              </button>
                              <button class="viewing-type viewing-type-4 ${viewType == 'view-4' ? 'active' : ''}">
                                ${window.tagalysIcon.view4(html)}
                              </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid__item small-down--one-whole medium-up--one-whole filter-wrapper" style="display:none;">
                      <div class="flex filters-action-block" style="display:none;">
                        <span class="result-counter">
                          ${
                            helpers.getTotalProductsCount() > 1
                              ? `${helpers.getTotalProductsCount()} Results`
                              : `${helpers.getTotalProductsCount()} Result`
                          }
                        </span>
                        <div id="toggle-tg-filter-v2" class="toggle-tg-filter">
                          ${window.tagalysIcon.toggleFilter(html)}
                          <span class="mobile-facets__open-label button-label">Filter </span>
                        </div>
                      </div>

                    </div>
                    <div class="grid__item one-whole search-result-count" style="display:none;">Showing <span>${
                      helpers.getCurrentPage() * window.plp_vars.plp_limit -
                      (window.plp_vars.plp_limit - 1)
                    } - ${totalpagecount}</span> of ${helpers.getTotalProductsCount()} Results</div>
                    <div class="collection-products-main">
                      <div class="medium-up--one-fifth grid__item collection_tg_filter-wrap ${helpers.canShowFiltersInDrawer() ? `` : `open`}">
                        <div class="collection_tg_filter_mobile_footer">
                          <div class="filter__label clear-all-filters">
                            <button type="button" class="clear-all-filters-btn" onclick=${() => {
                              helpers.clearAllFilters();
                              clearAllFilterDataLayerEvent(props);
                            }}>
                              ${
                                showClearAllFiltersAction > 0
                                  ? html`
                                Clear`
                                  : "Clear"
                              }
                            </button>
                          </div>
                          <div class="apply-filter-count" onClick=${
                            props.helpers.closeFilterDrawer
                          }>
                            Apply
                            <span class="mobile-totalCount">${
                              helpers.getTotalProductsCount()
                                ? "(" + helpers.getTotalProductsCount() + ")"
                                : ""
                            }</span>
                          </div>
                        </div>
                        <div class="collection_tg_filter_mobile_header">
                          <div>${window.plp_vars.collectionName}</div>
                          <button class="close-filter filter-drawer-toggle" onClick=${
                            props.helpers.closeFilterDrawer
                          }>
                            ${window.tagalysIcon.close(html)}
                          </button>
                        </div>
                        <div class="mobile-appliedFilters collection__filter-actions">
                          <${args.templates.appliedFilters} />
                        </div>
                        <${args.templates.filters} />
                      </div>
                      <div class="collection__products grid__item medium-up--one-whole medium-up--four-fifths">
                        <div class="collection__filter-actions">
                        <${args.templates.appliedFilters} />
                      </div>
                      <div role="list" class="grid grid--flex display--grid">
                          ${previousPageLoad}
                        <${args.templates.products} />
                        <${args.templates.productListFooter} />
                      </div>
                      ${helpers.isFilterDrawerOpen()
                        ? html`
                          <div class="filter-overlay" onclick=${helpers.closeFilterDrawer} />
                        `
                        : ""
                      }
                    </div>
                  </div>
                </div>
                <${args.templates.footer} />
              </div>`;
    },
  },
  header: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="plp-header">
                <div class="collection__tabs">
                  <button id="toggle-tg-filter" class="collection__tab collection__tab--filter filter-drawer-toggle" onclick=${
                    helpers.openFilterDrawer
                  }>
                    <span class="filter-drawer-btn open-filter-drawer">
                      ${window.tagalysIcon.openFilter(html)}
                      Filter
                      ${window.renderHelpers.collectionResultsCount(html, args)}
                    </span>
                    <span class="filter-drawer-btn close-filter-drawer" onClick=${
                      props.helpers.closeFilterDrawer
                    }>
                      ${window.tagalysIcon.minus(html)}
                      Filter
                      ${window.renderHelpers.collectionResultsCount(html, args)}
                    </span>
                  </button>
                  <div class="collection__tab collection__tab--clear medium-up--hide">
                    <div class="clear-filters__container" style="display: none;">
                      <button type="reset" class="filter__label clear-filters__btn">
                        ${window.tagalysIcon.clearFilters(html)}
                        <span>${args.labels.filters.clearFilters}</span>
                      </button>
                    </div>
                  </div>
                  <div class="collection__tab collection__tab--grid medium-down--hide medium-up--one-sixth">
                    <div></div>
                  </div>
                  <div class="collection__tab collection__tab--sort medium-up--one-sixth">
                    <div class="collection__tab--sort-overlay">
                      <span>
                        ${args.labels.sortOptions.sortBy}
                        ${window.tagalysIcon.sortBy(html)}
                      </span>
                    </div>
                    ${
                      filterOptions.includeSortOptionsInFilters
                        ? ""
                        : html`
                          <${args.templates.sortOptions} />
                        `
                    }
                  </div>
                </div>
              </div>`;
    },
  },
  product: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var product = props.product;

      var productOptions = helpers.getTemplateOptions("product");

      var navigateToProductDetailPage = (event) => {
        try {
          sessionStorage.setItem("tagalys_product_card_clicked", product.id);
        } catch (e) {
          console.log('Failed to save breadcrumb map to sessionStorage', e);
        }
        helpers.navigateToProductDetailPage(event, product);
      }
      // Retrieve the product link using the productPageUrl helper
      var productLink = productOptions.productPageUrl(product);

      let badge = "", badgeStyles = "";
      var fomoBadgeStyle = "";
      var promo_text = "";
      var promo_style = "";
      var promo_link = "";
      var promo_format_only = false;

      const {price, compareAtPrice} = window.renderHelpers.getPrice(product)
      let {isOnlyInStore, isOnlyInStoreClass, offer, offerProperty} = window.renderHelpers.getTags(product.tags)


      
      if (!badge) {
        var collections = product.collections;
        var collectionsMetaObject = window.theme.collectionMetaobjects;
        var tempbadge = false;
        for (var i = 0; i < collectionsMetaObject.length; i++) {
          let badgeCollections = collectionsMetaObject[i].collections || [];
          if(badgeCollections.length > 0){
            for (var j = 0; j < collections.length; j++) {
              let matchFound = badgeCollections.some(bc => String(bc.id) === String(collections[j].id));
              if (matchFound) {
                badge = collectionsMetaObject[i].badge_text;
                badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                if (collectionsMetaObject[i].badge_border_color) {
                  badgeStyles = `${badgeStyles}; border-color:${collectionsMetaObject[i].badge_border_color};`;
                }
                if (collectionsMetaObject[i].opacity) {
                  badgeStyles = `${badgeStyles}; opacity:${collectionsMetaObject[i].opacity};`;
                }
                if (collectionsMetaObject[i].fomo_style == true) {
                  fomoBadgeStyle = "fomo-badge";
                } else if (collectionsMetaObject[i].default_style == true) {
                  fomoBadgeStyle = "default-badge";
                }
                tempbadge = true;
                break;
              }
            }
            if (tempbadge) {
              break;
            }
          }
        }
      }
      // Promo Callout
      var collections = product.collections;
      var promo_callout_metaobject = window.theme.promo_callout_metaobject;
      var temppromo = false;
      for (var i = 0; i < promo_callout_metaobject.length; i++) {
        for (var j = 0; j < collections.length; j++) {
          if (collections[j].id == promo_callout_metaobject[i].id) {
            promo_text = promo_callout_metaobject[i].promo_text;
            promo_style = `color: ${promo_callout_metaobject[i].text_colour};`;
            promo_link = `/collections/${collections[j].handle}`;
            temppromo = true;
            break;
          }
        }
        if (temppromo) {
          break;
        }
      }
      

      // Multibuy offer badges
      var multibuy_offer_discounts = window.theme.multibuy_offer_discounts || [];
      const currentPageHandle = window.theme && window.theme.currentPageHandle
        ? String(window.theme.currentPageHandle)
        : (window.location.pathname.includes('/collections/')
          ? window.location.pathname.split('/collections/')[1].split('/')[0].split('?')[0]
          : '');

      for (var i = 0; i < multibuy_offer_discounts.length; i++) {
        const offer = multibuy_offer_discounts[i];
        const discount_type = offer.discount_type;
        const discount_key = offer.discount_key || '';
        const collection_handle = offer.collectionHandle || '';
        const collectionTitle = offer.collectionTitle || '';
        if (offer.active === false || offer.active === 'false') continue;
        if (!discount_key && !collection_handle) continue;

        let isMatch = false;

        if (discount_type === "collection" || !discount_type) {
          if (collection_handle && currentPageHandle && String(currentPageHandle) === String(collection_handle)) {
            isMatch = true;
          }
          if (!isMatch && discount_key && currentPageHandle && String(currentPageHandle) === String(discount_key)) {
            isMatch = true;
          }
          if (!isMatch && product.collections && Array.isArray(product.collections)) {
            isMatch = product.collections.some(function(c) {
              if (!c) return false;
              const cHandle = typeof c === 'object' && c !== null ? c.handle : (typeof c === 'string' ? c : null);
              const cTitle = typeof c === 'object' && c !== null ? c.title : (typeof c === 'string' ? c : null);
              const cId = typeof c === 'object' && c !== null ? c.id : (typeof c === 'number' || typeof c === 'string' ? c : null);

              if (collection_handle && cHandle && String(cHandle) === String(collection_handle)) return true;
              if (discount_key && ((cHandle && String(cHandle) === String(discount_key)) || (cTitle && String(cTitle) === String(discount_key)))) return true;
              if (collectionTitle && cTitle && String(cTitle) === String(collectionTitle)) return true;
              if (offer.id && cId && String(cId) === String(offer.id)) return true;
              return false;
            });
          }
          if (!isMatch && product.tags && Array.isArray(product.tags)) {
            if (collection_handle && product.tags.includes(collection_handle)) isMatch = true;
            if (!isMatch && discount_key && product.tags.includes(discount_key)) isMatch = true;
          }
        }

        if (!isMatch && (discount_type === "tag" || !discount_type)) {
          if (product.tags && Array.isArray(product.tags)) {
            if (discount_key && product.tags.includes(discount_key)) isMatch = true;
            if (!isMatch && collection_handle && product.tags.includes(collection_handle)) isMatch = true;
          }
        }

        if (isMatch) {
          promo_text = offer.description || offer.title || "";
          promo_link = offer.collectionUrl || (collection_handle ? `/collections/${collection_handle}` : (discount_key ? `/collections/all/tagged/${discount_key}` : '#'));
          if (offer.color) {
            promo_style = `color: ${offer.color};`;
          }
          temppromo = true;
          promo_format_only = true;
          break;
        }
      }

      const variantId = product.variants?.[0]?.id || "";

      return html`
                  <div class="grid__item medium-down--one-half large-up--one-whole html2 product-card-wrapper">
                    <a href="${productLink}" title="${
                      product.title
                    }" class="collection__product-link">
                      <div class="product-card product-card--quick" data-pid="${
                        product.id
                      }" data-vid="${variantId}" data-offer="${offerProperty}" data-sku="${
                        product.variants[0].sku
                      }">
                        ${window.renderHelpers.productCard.wishlistButton(html, args)}
                        <div class="product-card__image">
                          <div class="product-card__image--wrapper" onClick=${navigateToProductDetailPage}>
                            ${window.renderHelpers.productCard.images(html, args)}
                          </div>
                          ${window.renderHelpers.productCard.actions(html, args, isOnlyInStoreClass)}
                        </div>
                        ${
                          badge != ""
                            ? html`<div style="${badgeStyles}" class="product-card__badge ${fomoBadgeStyle}" data-product-card-badge="${product.id}" data-badgestr="${badge}">${badge}</div>`
                            : ""
                        }
                        <div class="product-card__info">
                          <div class="product-card__details">
                            <div class="product-card__text">
                              <div data-oke-reviews-product-listing-rating=""></div>
                              ${
                                promo_text != ""
                                  ? html`<a href="${promo_link}" style="${promo_style || ''}" class="promo_callout" data-text="${promo_text.replace(/\"|\'/g, '').replace(/\s/g, '')}" data-currency="${window.theme.currentCurrency}">
                                  ${window.tagalysIcon.plpPromoImage(html)}
                                  ${window.tagalysIcon.quickviewPromoImage(html)}
                                  <span>${theme.CurrencySwitcher.getCurrencyHTML(promo_text, html, promo_format_only)}</span>
                                  </a>`
                                  : ""
                              }
                              <h4 class="product-card__title taglays" onClick=${navigateToProductDetailPage}>
                                <span>${product.title}</span>
                              </h4>
                              <div class="product-card__price product-card--flex"  onClick=${navigateToProductDetailPage}>
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        ${
                                          compareAtPrice === null
                                            ? html`
                                            <span
                                             class="product-price-regular"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(
                                                    price
                                                  ),
                                              }}
                                              />`
                                            : html`
                                            <span
                                             class="product-price-regular"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(
                                                    compareAtPrice
                                                  ),
                                              }}
                                             />`
                                        }
                                         ${
                                           helpers.isProductOnSale(
                                             compareAtPrice,
                                             price
                                           )
                                             ? html`
                                            <span
                                              class="sale-price-text-color product-price-discounted"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(price),
                                              }}
                                              />
                                            `
                                             : ""
                                         }
                                      </span>
                                    `
                                } ${
                                helpers.isProductOnSale(compareAtPrice, price)
                                  ? html`
                                      <span class="product-per-off ${
                                      window.theme.showPerOffMobile
                                        ? "show-per-off-mobile"
                                        : ""
                                      }${
                                      window.theme.showPerOffDesktop
                                        ? " show-per-off-desktop"
                                        : ""
                                      }">
                                        (-${Math.round(
                                          ((compareAtPrice - price) * 100) /
                                            compareAtPrice
                                        )}%)
                                      </span>
                                  ` : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>`;
    },
  },
  filters: {
    options: {
      collapsible: true,
      includeSortOptionsInFilters: false,
      autoCollapse: true,
      showAppliedFilters: true,
      showClearAllFilters: true,
      showClearActionForIndividualFilters: true,
      showMatchingProductsCount: window.theme.tagalysShowFilterItemsCount,
      defaultExpandedFilters: [],
      expandTopNFiltersByDefault: 1,
      showFiltersInDrawer: () => {
        return window.innerWidth <= 768;
      },
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction =
        props.showClearAllFilters && appliedFilters.length;
      var classes = ["filters"];
      if (props.collapsible) {
        classes.push("collapsible");
      }

      var className = classes.join(" ");
      return html`
              <div class="collection-filters-block">
                <${args.templates.filtersHeader} />

                ${
                  props.includeSortOptionsInFilters === "top"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
                ${filters.map(
                  (filter) =>
                    html`
                      <${args.templates.filter} filter=${filter} />
                    `
                )}
                ${
                  props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === "bottom"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
              </div>`;
    },
    callbacks: {
      afterEveryRender: function (helpers) {
        if( document.querySelector(plp_selector) ) document.querySelector(plp_selector).setAttribute('aria-busy', false)
        window.renderHelpers.attachSearchListener(helpers)
        window.renderHelpers.hideOpenedVariants();
        window.renderHelpers.updateProductCards(".product-card");
        window.renderHelpers.checkStickyElements();
      },
    },
  },
  filtersHeader: {
    render: function (html, args) {
      var props = args.props;
      return html``;
    },
  },
  appliedFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var appliedFilters = helpers.getAppliedFilters(true);
      if (!appliedFilters.length) {
        return html``;
      }

      return html`
              <ul class="applied-filters unstyled-list">
                ${appliedFilters.map((appliedFilter) => {
                  if (appliedFilter.type === "range") {
                    return html`
                      <li onClick=${() => {
                        helpers.clearFilter(appliedFilter.id);
                        removeFilterDataLayerEvent(props, appliedFilter.id);
                      }} class="applied-filter">
                          <span class="filter__label applied-filter-label"
                        dangerouslySetInnerHTML=${{
                          __html:
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )+'<span class="price-applied-space">-</span>'+
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          ),
                        }} />
                        <button class="filter__label applied-filter-action-clear">
                          ${window.tagalysIcon.closeIcon(html)}
                        </button>
                      </li>
                    `;
                  }
                  return appliedFilter.items.map((filterItem) => {
                    const filterItemName = appliedFilter.id == "size" ? filterItem.label.toUpperCase() : filterItem.label.toLowerCase();
                    return html`
                      <li
                        class="display-flex applied-filter"
                        onClick=${() => {
                          helpers.clearFilter(appliedFilter.id, filterItem.id);
                          removeFilterDataLayerEvent(
                            props,
                            appliedFilter.id,
                            filterItem
                          );
                        }}
                      >
                        <span class="filter__label applied-filter-label">
                          ${filterItemName}
                        </span>
                        <button class="filter__label applied-filter-action-clear">
                          ${window.tagalysIcon.closeIcon(html)}
                        </button>
                      </li>
                    `;
                  });
                })}
                  <li class="applied-filter filter__label clear-all-filters">
                    <button type="button" class="clear-all-filters-btn" onclick=${() => {
                      helpers.clearAllFilters();
                      clearAllFilterDataLayerEvent(props);
                    }}>
                      <span class="filter__label applied-filter-label">${args.labels.filters.clearAllFilters}</span>
                    </button>
                  </li>
              </ul>
            `;
    },
  },
  filter: {
    render: function (html, args) {
      return window.renderHelpers.filter(html, args);
    },
  },
  filterHeader: {
    render: function (html, args) {
      return window.renderHelpers.filterHeader(html, args);
    },
  },
  filterItems: {
    render: function (html, args) {
      var props = args.props;
      if (props.filter.type === "checkbox") {
        return html`
                <div class="filter__list filter-body filter-body-checkboxes ${props.filter.id}">
                  <${args.templates.filterCheckBoxes} filterId=${props.filter.id} filterItems=${props.filter.items} />
                </div>
              `;
      }
      return html`
              <div class="filter__list filter-body filter-body-range">
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterCheckBoxes: {
    render: function (html, args) {
      var props = args.props;
      let showLessHtml = "";
      let show_more_count = props.filterItems.length;
      return html`
              <ul class="filter-checkboxes">
                ${props.filterItems.map((filterItem, index) => {
                  let classname = "";
                  let showMoreHtml = "";

                  if (window.innerWidth < 768 && props.filterId == "colour") {
                    if (index == 18) {
                      show_more_count = show_more_count - 18;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more"><button class="show_more_color">${args.labels.ui.showMoreCount.replace('{{ count }}', show_more_count)}</button></li>`;
                      showLessHtml = html`<li class="show_less" style="display:none;"><button class="show_less_color">${args.labels.ui.showLess}</button></li>`;
                    }
                  } else if (index == 5) {
                      show_more_count = show_more_count - 5;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more"><button class="show_more_click">${args.labels.ui.showMoreCount.replace('{{ count }}', show_more_count)}</button></li>`;
                      showLessHtml = html`<li class="show_less" style="display:none;"><button class="show_less_click">${args.labels.ui.showLess}</button></li>`;
                  }

                  return html`
                 ${showMoreHtml}
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                    index=${index}
                    class=${classname}
                  >
                  ${
                    filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : ""
                  }
                </${args.templates.checkboxFilterItem}>
              `;
                })}
                ${showLessHtml}
              </ul>
            `;
    },
  },
  checkboxFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      const onFilterClick = (event) => {
        event.stopPropagation();
        if( document.querySelector(plp_selector) ) document.querySelector(plp_selector).setAttribute('aria-busy', true)
        if (props.filterItem.selected) {
          helpers.clearFilter(props.filterId, props.filterItem.id);
          removeFilterDataLayerEvent(props, props.filterId, props.filterItem);
        } else {
          helpers.applyFilter(props.filterId, props.filterItem.id);
          applyFilterDataLayerEvent(props);
        }
      };
      var icon = "";
      var code = "#1A1A1A";
      if (props.filterId == "colour") {
        var filterName = String(props.filterItem.label.trim()).toLowerCase();
        if (window.plp_vars.coloursMeta[filterName]) {
          if (window.plp_vars.coloursMeta[filterName].icon) {
            icon = window.plp_vars.coloursMeta[filterName].icon;
          } else if (window.plp_vars.coloursMeta[filterName].code) {
            code = window.plp_vars.coloursMeta[filterName].code;
          }
        }
      }
      var colour_icon = html`<span></span>`;
      if (props.filterId == "colour") {
        if (icon != "") {
          colour_icon = html`<span class="colour-icon"><img width="16" height="16" loading="lazy" src="${icon}" /></span>`;
        } else {
          colour_icon = html`<span class="colour-icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Colour">
                            <circle  cx="8" cy="8" r="8" fill="${code}"></circle>
                            </g>
                            </svg></span>`;
        }
      }

      return html`
              <li class="filter-item ${props.filterId}" data-filter-item-id=${
        props.filterItem.id
      } onClick=${onFilterClick}>
                <div class="filter__type filter-checkbox-and-label ${props.filterItem.label.toLowerCase()}">
                  ${colour_icon}
                  <input name="filter_${props.filterItem.id}" class="checkbox" checked=${
                    props.filterItem.selected
                  } type="checkbox" aria-label=${args.labels.filters.filterItem} />
                  <span class="filter-item-label-and-count">
                    <span class="filter-item-label">${props.filterItem.label.toLowerCase()}</span>
                    ${
                      props.showMatchingProductsCount
                        ? html`
                          <span class="filter-item-count">(${props.filterItem.count})</span>
                        `
                        : ""
                    }
                  </span>
                </div>
                ${props.children}
              </li>
            `;
    },
  },
  rangeSliderFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      let {priceLabel, minPriceValue, maxPriceValue, priceValueLeft, priceValueRight, priceValueLeftClass, priceValueRightClass} = window.renderHelpers.rangeSliderFilterItem(html, args)

      return html`
              <div class="range-slider filter-item">
                <span class="max-range-info" style="display:none;">${priceLabel}</span>
                <div class="price-range-value" style="display:none;">
                  <span class="price-range__label--min-price ${priceValueLeftClass}" style="left: ${priceValueLeft};">
                    ${minPriceValue}
                  </span>
                  <span class="price-range__label--max-price ${priceValueRightClass}" style="right: ${priceValueRight};">
                    ${maxPriceValue}
                  </span>
                </div>

                <div></div>
                <div class="price-range__input-group">
                  <div class="min-price">
                  <span class="min-label">${args.labels.filters.min}</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMin"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=0
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                      onfocus=${(this.value = "")}
                      aria-label=${args.labels.filters.priceRangeInput}
                    />
                    <label style="display:none;" for="priceRangeMin">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.min,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                  <span class="to" style="display:none;">${
                    args.labels.filters.rangeFilterValueSeparator
                  }</span>
                   <div class="min-price">
                  <span class="min-label">${args.labels.filters.max}</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMax"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=0
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                    <label style="display:none;" for="priceRangeMax">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.max,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                </div>
                <div ref=${props.sliderRef} />
              </div>
            `;
    },
  },
  sortOptionInFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var filterOptions = helpers.getTemplateOptions("filters");
      var appliedSortOption = helpers.getAppliedSortOption();
      var sortOptions = helpers.getSortOptions();

      let classes = ["filter"];
      let isCollapseOpen = false;
      if (filterOptions.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
        if (isCollapseOpen) {
          classes.push("is-expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");

      return html`
              <div data-filter-id="sort_options" class=${className}>
                <${args.templates.filterHeader} filterHeading=${
                  args.labels.sortOptions.sortBy
                } filterId=${"sort_options"} />
                <div class="filter-body filter-body-checkboxes">
                  <ul class="filter-checkboxes">
                    ${sortOptions.map((sortOption) => {
                      const checked = sortOption.id === appliedSortOption.id;
                      return html`
                        <li
                          class="filter-item"
                          data-filter-item-id=${sortOption.id}
                          onClick=${() => {
                            helpers.applySortOption(sortOption.id);
                            clickSortOptionDataLayerEvent(helpers);
                          }}
                        >
                          <span class="filter-checkbox-and-label">
                            <input name="filter-item-${sortOption.id}" class="checkbox" checked=${checked} type="checkbox" />
                            <span class="filter-item-label-and-count">
                              <span class="filter-item-label">${
                                sortOption.label
                              }</span>
                            </span>
                          </span>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              </div>
            `;
    },
  },
  downArrow: {
    // eslint-disable-next-line no-unused-vars
    render: function (html, args) {
      return html`
              ${window.tagalysIcon.chevron.down(html)}
              ${window.tagalysIcon.chevron.up(html)}
            `;
    },
  },
  addToCartForm: {
    render: function (html, args) {
      const product = args.props.product;
      if( !product ) return html``;
      const variants = product.variants;
      let {isOnlyInStore, isOnlyInStoreClass} = window.renderHelpers.getTags(product.tags)

      return html`
              <form action="${
                window.plp_vars.cart_add_url
              }" method="post" enctype="multipart/form-data" class="form">
                <input type="hidden" name="quantity" value="1" />
                <${args.templates.variantSelect} product=${product} />
                <${args.templates.variantOption} product=${product} />
                ${
                  variants.length > 1
                    ? html`
                      <button class="product__add--show-variants" type="button" aria-label="${args.labels.products.quickAdd}">
                        ${window.tagalysIcon.cart(html)}
                      </button>
                      <button
                        type="button"
                        class="product__add--mobile product__add--show-variants"
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.cart(html)}
                      </button>
                    `
                    : html`
                      <button
                        class="product__add"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                      ${window.tagalysIcon.cart(html)}
                      </button>
                      <button
                        class="product__add--mobile"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.shoppingBag(html)}
                        ${window.tagalysIcon.checkmark(html)}
                      </button>
                    `
                }
              </form>
            `;
    },
  },
  variantOption: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      return html`
          <div class="product-card__variant-picker product-card__variant-picker--with-options">
            ${window.renderHelpers.variantOption.header(html, args)}
            <div role="list" class="product-card__variants">
              ${window.renderHelpers.variantOption.variantList(html, args)}
              <div role="listitem" class="product-card__variant-container">
                <button
                  type="button"
                  class="close-show-variants"
                  aria-label="${args.labels.products.closeVariants}"
                >
                  ${window.tagalysIcon.closeShowVariants(html)}
                </button>
              </div>
            </div>

            <div role="list" class="product-card__mobile-variants">
              ${window.renderHelpers.variantOption.variantListMobile(html, args)}
            </div>
          </div>
        `;
    },
  },
  variantSelect: {
    render: function (html, args) {
      return window.renderHelpers.variantSelect(html, args);
    },
  },
  productObj: {
    // Custom template to render variants
    render: function (html, args) {
      return window.renderHelpers.productObj(html, args)
    },
  },
  
products: {
  render: function (html, args) {
    var props = args.props;
    var helpers = props.helpers;
    var products = helpers.getProducts();
    viewPLPDataLayerEvent(props.helpers, ".collection__products .product-card");
    var currentLang = window.theme.store === "EU" && window.Weglot ? window.Weglot.getCurrentLang() : "en";
    var displaybyLang = window.theme.hideInlineAdsNonEn && currentLang !== "en" ? true : false;

    function isExcludedForCurrentCollection(ad) {
      var exclusions = Array.isArray(ad.exclusion_collection) ? ad.exclusion_collection : [];
      var currentCollectionGID = window.theme && window.theme.collectionGID;
      return currentCollectionGID && exclusions.includes(currentCollectionGID);
    }

    var safeAdsSource = Array.isArray(removeSamePositionAds) ? removeSamePositionAds : [];

    var validOnmiPlpAdArray = safeAdsSource.filter(function (ad) { return isActiveInlineAd(ad);}).filter(function (ad) {
        return !isExcludedForCurrentCollection(ad);
      });

    var adsByPosition = validOnmiPlpAdArray.reduce(function (acc, ad) {
      if (ad && typeof ad.position === "number") {
        acc[ad.position] = ad;
      }
      return acc;
    }, {});

    var inlineAdHTML = function (inlineAdMetaObjDetails, productItem) {
     return html`
            <div class="grid__item medium-down--one-half large-up--one-whole html2">
              <a href="${inlineAdMetaObjDetails?.link?.url}" title="${inlineAdMetaObjDetails.title}" class="collection__product-link">
                <div class="product-card product-card--quick" >

                  <div class="product-card__image">
                    <div class="product-card__image--wrapper small-down--hide">
                              <img
                                width="251"
                                src="${formatShopifyImageUrl(inlineAdMetaObjDetails.desktop_image, 251)}"
                                srcset="${generateShopifySrcset(inlineAdMetaObjDetails.desktop_image)}"
                                class="component-image__image"
                                alt="${inlineAdMetaObjDetails?.link?.text}"
                              />
                    </div>
                    <div class="product-card__image--wrapper large-up--hide">
                              <img
                                width="251"
                                src="${formatShopifyImageUrl(inlineAdMetaObjDetails.mobile_image, 251)}"
                                srcset="${generateShopifySrcset(inlineAdMetaObjDetails.mobile_image)}"
                                class="component-image__image"
                                alt="${inlineAdMetaObjDetails?.link?.text}"
                              />
                    </div>
                    ${window.renderHelpers.productCard.actions(html, args, "hide")}
                  </div>

                  <div class="product-card__info">
                    <div class="product-card__details">
                      <div class="product-card__text">
                        <div data-oke-reviews-product-listing-rating=""></div>
                        <h4 class="product-card__title taglays">
                          <span></span>
                        </h4>
                        <div class="product-card__price product-card--flex">


                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
      `};

    var tileCounter = 0;

    return html`
      ${products.map(function (product, index) {
        if (!product || !product.images || product.images.length === 0) {
          return "";
        }

        var nodes = [];

        var canShowAds = !displaybyLang && !!window.theme.collectionTitle;

        if (canShowAds) {
          while (true) {
            var nextTile = tileCounter + 1; 
            var adForThisTile = adsByPosition[nextTile];

            if (!adForThisTile) {
              break;
            }

            var adVisibleOnDevice = isAdVisibleOnCurrentDevice(adForThisTile);
            if (!adVisibleOnDevice) {
              break;
            }

            nodes.push(inlineAdHTML(adForThisTile, product));
            tileCounter += 1;

          }
        }
        nodes.push(
          html`<${args.templates.product}
            key=${product.id || product.handle || index}
            product=${product}
          />`
        );
        tileCounter += 1;

        return html`${nodes}`;
      })}
    `;
  },

  callbacks: {
    // eslint-disable-next-line no-unused-vars
    afterInitialRender: function (helpers) {
      window.renderHelpers.updateProductCards(".product-card");
    },
  },
},

  sortOptions: {
    render: function (html, args) {
      return window.renderHelpers.sortOptions(html, args);
    },
  },

  productsPerPage: {
    render: function (html, args) {
      return window.renderHelpers.productsPerPage(html, args);
    },
  },
  productListHeader: {
    render: function (html, args) {
      return html`
              <${args.templates.infoAndActions} />
            `;
    },
  },
  noResults: {
    options: "",
    render: function (html, args) {
      return window.renderHelpers.noResults(html, args);
    },
  },
  paginationLinks: {
    options: {
      showNumberedPageLinks: true,
      numberedPageLinksWindowSize: 3,
      showPreviousPageLink: true,
      showFirstPageLink: true,
      showNextPageLink: true,
      scrollTop: true,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var pagesToDisplay = helpers.getPagesToDisplay(
        props.numberedPageLinksWindowSize
      );
      if (pagesToDisplay.length <= 1) {
        return;
      }
      var currentPage = helpers.getCurrentPage();
      var hasPreviousPage = helpers.hasPreviousPage();
      var hasNextPage = helpers.hasNextPage();

      var goToFirstPage = () => {
        helpers.goToPage(1);
      };

      return html`
          <ul class="ais-pagination">
            ${
              props.showFirstPageLink
                ? html`
                  <li class="ais-pagination__item ais-pagination__item--first">
                    <button
                      class=${`ais-pagination__link${
                        currentPage === 1 ? " disabled" : ""
                      }`}
                      onclick=${currentPage === 1 ? undefined : goToFirstPage}
                    >
                      &lt;
                    </button>
                  </li>
                `
                : ""
            }
            ${
              props.showPreviousPageLink
                ? html`
                  <li
                    class=${`ais-pagination__item ais-pagination__item--previous${
                      !hasPreviousPage ? " ais-pagination__item--disabled" : ""
                    }`}
                  >
                    <button
                      class=${`ais-pagination__link${
                        !hasPreviousPage ? " disabled" : ""
                      }`}
                      onclick=${
                        currentPage === 1 ? undefined : helpers.goToPreviousPage
                      }
                    >
                      ${"<"}
                    </button>
                  </li>
                `
                : ""
            }
            ${
              props.showNumberedPageLinks
                ? pagesToDisplay.map((pageDetail) => {
                    console.log("showNumberedPageLinks", pageDetail);
                    var classes = ["ais-pagination__item"];
                    var showEllipsis = pageDetail.jumpAfter;
                    if (pageDetail.current) {
                      classes.push("ais-pagination__item--active");
                    }
                    if (pageDetail.jumpAfter) {
                      classes.push("page-jump-over");
                    }

                    var className = classes.join(" ");
                    if (pageDetail.page == helpers.getTotalPages()) {
                      return html``;
                    }

                    return html`
                    <li class=${`${className}`}>
                      <button
                        class="ais-pagination__link"
                        onclick="${() => {
                          !showEllipsis && helpers.goToPage(pageDetail.page);
                        }}"
                      >
                        ${showEllipsis ? "..." : pageDetail.page}
                      </button>
                    </li>
                  `;
                  })
                : ""
            }
            ${
              props.showNextPageLink
                ? html`
              ${
                helpers.getCurrentPage() != helpers.getTotalPages()
                  ? html`
                  <li class="ais-pagination__item">
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            helpers.goToPage(helpers.getTotalPages());
                          }}"
                        >
                          ${helpers.getTotalPages()}
                        </button>
                      </li>
                  `
                  : html`
                  <li class="ais-pagination__item ais-pagination__item--active">
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            helpers.goToPage(helpers.getTotalPages());
                          }}"
                        >
                          ${helpers.getTotalPages()}
                        </button>
                      </li>
                  `
              }
                  <li
                    class=${`ais-pagination__item ais-pagination__item--next${
                      !hasNextPage ? " ais-pagination__item--disabled" : ""
                    }`}
                  >
                    <button
                      class=${`ais-pagination__link${
                        !hasNextPage ? " disabled" : ""
                      }`}
                      onclick=${hasNextPage ? helpers.goToNextPage : undefined}
                    >
                      ${">"}
                    </button>
                  </li>
                `
                : ""
            }
          </ul>
        `;
    },
  },
  loadPrevious: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      return html`<div class="previous-products-load-wrapper text-center m-b-xs">
        <button class="load-previous  btn btn--primary" onclick=${props.helpers.loadPreviousPage}>
          ${helpers.isLoading()
          ? args.labels.pagination.loading
          : args.labels.pagination.loadPrevious}
        </button>
        </div>
      `
    },
  },
  pagination: {
    options: {
      infiniteScroll: true,
      trackPageNumbersForInfiniteScroll: true,
      showLoadNextAfterEvery: 1
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var plp_limit = window.plp_vars.plp_limit;
      window.productListingPageInstance = helpers;
      let shownProductsCount = plp_limit - 8;
      if (props.infiniteScroll) {
        collectionFiltersSticky();
        if (helpers.isLoading()) {
          const productCards = document.querySelectorAll('.product-card-wrapper.last-products');
          if (productCards && productCards.length > 0) {
            productCards.forEach(card => {
              card.style.removeProperty('display');
              card.classList.remove('last-products')
            });
          }
          let placeholderCount = plp_limit;
          let placeholderHtml = [];

          for (var i = 0; i < placeholderCount; i++) {

            let _html = html`<div class="grid__item medium-down--one-half large-up--one-whole html2 placeholder-product-card">
            ${window.tagalysIcon.placeholderProductCard(html)}
              </div>`;
              if (window.innerWidth <= 989) {
                _html = html`<div class="grid__item medium-down--one-half large-up--one-whole html2 placeholder-product-card">${window.tagalysIcon.placeholderProductCardSmall(html)}</div>`;
              }
            placeholderHtml.push(_html);
          }
          return html`${placeholderHtml}`;
        }
        else {
          let buttonHtml = html`<button class="load-next btn btn--primary" onclick=${props.helpers.loadNextPage
            }>
              ${helpers.isLoading()
              ? args.labels.pagination.loading
              : args.labels.pagination.loadNext
            }
            </button>`;

          if (!helpers.hasNextPage()) {
            buttonHtml = '';
          }
          if (!helpers.hasNextPage() && helpers.canLoadPreviousResults() == false) {
            shownProductsCount = helpers.getTotalProductsCount();
          }
          else {
            const productCards = document.querySelectorAll('.product-card-wrapper');
            if (productCards && productCards.length > 0) {
              const lastProductCard = Array.from(productCards).slice(-8);
              if (lastProductCard && lastProductCard.length > 0) {
                lastProductCard.forEach(card => {
                  card.style.display = 'none';
                  card.classList.add('last-products');
                });
              }
              shownProductsCount = productCards.length - 8;
            }

          }
          const percentage = Number(Math.min(100, Math.max(0, (shownProductsCount / helpers.getTotalProductsCount()) * 100)).toFixed(2));
          return html`<div class="infinite-scroll-content text-center m-b-xs">
           <div class="grid__item one-whole search-result-count">You've viewed ${shownProductsCount} of ${helpers.getTotalProductsCount()} products</div>
           <div class="progress-bar-container">
            <div class="progress-bar">
              <div class="load-more-progress-fill" style="width: ${percentage}%;"></div>
            </div>
          </div>${buttonHtml}
            </div>
          `;
        }
        // if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
        //   // return html`
        //   //         <${args.templates.loadNext} />
        //   //       `;
        // }
        // return "";
      }
      return html`
              <div class="grid__item one-whole collection__pagination pagination">
                <${args.templates.paginationLinks} />
              </div>
            `;
    },
  },
  infoAndActions: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var filterOptions = helpers.getTemplateOptions("filters");

      var getResultsLabel = () => {
        return args.labels.searchResults.productsCount.replace(
          "{{productsCount}}",
          helpers.getTotalProductsCount()
        );
      };

      return html`
              <div class="collection__tab collection__tab--sort display-flex align-center justify-center">
                <span class="display-flex hide"
                  >Filter
                  ${window.renderHelpers.collectionResultsCount(html, args)}
                </span>
                ${
                  filterOptions.includeSortOptionsInFilters
                    ? ""
                    : html`
                      <${args.templates.sortOptions} />
                    `
                }
              </div>
            `;
    },
  },
  callbacks: {
    onSuccessfulAPICall: function (response, helpers) {
      window.renderHelpers.hideOpenedVariants();
      window.renderHelpers.checkStickyElements();

      return response;
    },
  },
};

var shopifyProductListingPageTemplates = {
  widget: {
    labels: getTagalysLabels(),
    options: {
      includeTagalysCSS: false,
      canAppendQueryStringToUrl: true,
      perPage: 16,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      if (helpers.isInitialLoading()) {
        return html`
                <${args.templates.loader} />
              `;
      }

      let classes = ["plp", "search-results", "results-tagalys", "page-width-wide"];
      if (helpers.isFilterDrawerOpen()) {
        classes.push("filter-drawer-opened");
      }

      if (helpers.isLoading()) {
        classes.push("loading");
      }

      if (helpers.canShowFiltersInDrawer()) {
        classes.push("show-filters-in-drawer");
      }

      var className = classes.join(" ");

      let previousPageLoad = '';
      if (helpers.canLoadPreviousResults() == true && helpers.getCurrentPage() > 1) {
        previousPageLoad = html`<${args.templates.loadPrevious} />`;
      }
      return html`
              <div class=${className}>
                <${args.templates.header} />
                <div class="grid grid__uniform collection__container">
                  <div class="grid__item small-down--one-whole medium-up--one-whole filter-wrapper">
                    <div class="flex filters-action-block" style="display:none;">
                      <span class="result-counter">
                        ${
                          helpers.getTotalProductsCount() > 1
                            ? `${helpers.getTotalProductsCount()} Results`
                            : `${helpers.getTotalProductsCount()} Result`
                        }
                      </span>
                      <div id="toggle-tg-filter-v2" class="toggle-tg-filter">
                        ${window.tagalysIcon.toggleFilter(html)}
                        <span class="mobile-facets__open-label button-label">Filter </span>
                      </div>
                    </div>
                    <div class="collection__filters">
                      <div class="collection__filter-wrap collection_tg_filter-wrap">
                        <div class="collection-sort-block">
                          <${args.templates.productListHeader} />
                        </div>
                        <${args.templates.filters} />
                      </div>
                    </div>
                  </div>
                  <div class="collection__products grid__item medium-up--one-whole medium-up--four-fifths">
                    <div role="list" class="grid grid--flex display--grid">
                      ${previousPageLoad}
                      <${args.templates.products} />
                      <${args.templates.productListFooter} />
                    </div>
                    ${
                      helpers.isFilterDrawerOpen()
                        ? html`
                          <div class="filter-overlay" onclick=${helpers.closeFilterDrawer} />
                        `
                        : ""
                    }
                  </div>
                </div>
                <${args.templates.footer} />
              </div>
            `;
    },
  },
  header: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="plp-header">
                <div class="collection__tabs">
                  <button id="toggle-tg-filter" class="collection__tab collection__tab--filter filter-drawer-toggle">
                    <span class="filter-drawer-btn open-filter-drawer" onclick=${
                      helpers.openFilterDrawer
                    }>
                      ${window.tagalysIcon.plus(html)}
                      Filter
                      ${window.renderHelpers.collectionResultsCount(html, args)}
                    </span>
                    <span class="filter-drawer-btn close-filter-drawer" onClick=${
                      props.helpers.closeFilterDrawer
                    }>
                      ${window.tagalysIcon.minus(html)}
                      Filter
                      ${window.renderHelpers.collectionResultsCount(html, args)}
                    </span>
                  </button>
                  <div class="collection__tab collection__tab--clear medium-up--hide">
                    <div class="clear-filters__container" style="display: none;">
                      <button type="reset" class="filter__label clear-filters__btn">
                        ${window.tagalysIcon.clearFilters(html)}
                        <span>${args.labels.filters.clearFilters}</span>
                      </button>
                    </div>
                  </div>
                  <div class="collection__tab collection__tab--grid medium-down--hide medium-up--one-sixth">
                    <div></div>
                  </div>
                  <div class="collection__tab collection__tab--sort medium-up--one-sixth">
                    <div class="collection__tab--sort-overlay">
                      <span>
                        ${args.labels.sortOptions.sortBy}
                        ${window.tagalysIcon.chevron.down(html)}
                      </span>
                    </div>
                    ${
                      filterOptions.includeSortOptionsInFilters
                        ? ""
                        : html`
                          <${args.templates.sortOptions} />
                        `
                    }
                  </div>
                </div>
              </div>
            `;
    },
  },
  product: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var product = props.product;
      var productOptions = helpers.getTemplateOptions("product");

      var navigateToProductDetailPage = (event) => {
        try {
          sessionStorage.setItem("tagalys_product_card_clicked", product.id);
        } catch (e) {
          console.log('Failed to save breadcrumb map to sessionStorage', e);
        }
        helpers.navigateToProductDetailPage(event, product);
      }
      // Retrieve the product link using the productPageUrl helper
      var productLink = productOptions.productPageUrl(product);

      const {price, compareAtPrice} = window.renderHelpers.getPrice(product)
      let {isOnlyInStore, isOnlyInStoreClass, badge, badgeStyles} = window.renderHelpers.getTags(product.tags)

      if (!badge) {
        var collections = product.collections;
        var collectionsMetaObject = window.theme.collectionMetaobjects;
        var tempbadge = false;
        for (var i = 0; i < collectionsMetaObject.length; i++) {
          let badgeCollections = collectionsMetaObject[i].collections || [];
          if(badgeCollections.length > 0){
            for (var j = 0; j < collections.length; j++) {
              let matchFound = badgeCollections.some(bc => String(bc.id) === String(collections[j].id));
              if (matchFound) {
                badge = collectionsMetaObject[i].badge_text;
                badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                tempbadge = true;
                break;
              }
            }
          }
          if (tempbadge) {
            break;
          }
        }
      }

      return html`
                    <div class="grid__item medium-down--one-half large-up--one-whole html2 product-card-wrapper">
                      <div class="product-card product-card--quick" data-sku="${
                        product.variants[0].sku
                      }">
                        ${window.renderHelpers.productCard.wishlistButton(html, args)}
                        <div class="product-card__image">
                          <div class="product-card__image--wrapper" onClick=${navigateToProductDetailPage}>
                            <a href="${productLink}" title="${product.title}">
                              ${window.renderHelpers.productCard.images(html, args)}
                            </a>
                          </div>
                          ${window.renderHelpers.productCard.actions(html, args, isOnlyInStoreClass)}
                        </div>
                        <div class="product-card__info" onClick=${navigateToProductDetailPage}>
                          <div class="product-card__details">
                            <div class="product-card__text">
                              <div data-oke-reviews-product-listing-rating=""></div>
                              <h4 class="product-card__title taglays">
                                <a href="${productLink}"><span>${
                                  product.title
                                }</span></a>
                              </h4>
                              <div class="product-card__price">
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        ${
                                          helpers.isProductOnSale(
                                            compareAtPrice,
                                            price
                                          )
                                            ? html`
                                              <span class="sale-price-text-color product-price-discounted" dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     price
                                                   ),
                                               }}
                                              />
                                            `
                                            : ""
                                        }
                                        <span class="product-price-regular"
                                        dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                    compareAtPrice === null
                                                      ? price
                                                      : compareAtPrice
                                                  ),
                                               }}
                                              />
                                      </span>
                                    `
                                } ${
                                  helpers.isProductOnSale(compareAtPrice, price)
                                    ? html`
                                    <span class="product-per-off ${
                                      window.theme.showPerOffMobile
                                        ? "show-per-off-mobile"
                                        : ""
                                    }${
                                      window.theme.showPerOffDesktop
                                        ? " show-per-off-desktop"
                                        : ""
                                    }">
                                      -${Math.round(
                                        ((compareAtPrice - price) * 100) /
                                          compareAtPrice
                                      )}% Off
                                    </span>
                                  `
                                  : ""
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
    },
  },
  filters: {
    options: {
      collapsible: true,
      includeSortOptionsInFilters: false,
      autoCollapse: true,
      showAppliedFilters: true,
      showClearAllFilters: true,
      showClearActionForIndividualFilters: true,
      showMatchingProductsCount: window.theme.tagalysShowFilterItemsCount,
      defaultExpandedFilters: [],
      showFiltersInDrawer: () => {
        return window.innerWidth <= 768;
      },
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction =
        props.showClearAllFilters && appliedFilters.length;
      var classes = ["filters"];
      if (props.collapsible) {
        classes.push("collapsible");
      }

      var className = classes.join(" ");
      return html`
              <div class="collection__filter-actions">
                ${
                  props.showAppliedFilters
                    ? html`
                      <${args.templates.appliedFilters} />
                    `
                    : ""
                }
                ${
                  showClearAllFiltersAction
                    ? html`
                      <div class="filter__label clear-all-filters">
                        <button type="button" class="clear-all-filters-btn" onclick=${() => {
                          helpers.clearAllFilters();
                          clearAllFilterDataLayerEvent(props);
                        }}>
                          ${args.labels.filters.clearAllFilters}
                        </button>
                      </div>
                    `
                    : ""
                }
              </div>
              <div class="collection-filters-block">
                <${args.templates.filtersHeader} />

                ${
                  props.includeSortOptionsInFilters === "top"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
                ${filters.map(
                  (filter) =>
                    html`
                      <${args.templates.filter} filter=${filter} />
                    `
                )}
                ${
                  props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === "bottom"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
              </div>
            `;
    },
    callbacks: {
      afterEveryRender: function (helpers) {
        window.renderHelpers.attachSearchListener(helpers)
        //customTagalysActionEvents(helpers);
        window.renderHelpers.hideOpenedVariants()
        window.renderHelpers.updateProductCards(".product-card");
      },
    },
  },
  filtersHeader: {
    render: function (html, args) {
      var props = args.props;
      return html``;
    },
  },
  appliedFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var appliedFilters = helpers.getAppliedFilters(true);
      if (!appliedFilters.length) {
        return html``;
      }

      return html`
              <ul class="applied-filters unstyled-list">
                ${appliedFilters.map((appliedFilter) => {
                  if (appliedFilter.type === "range") {
                    return html`
                      <li onClick=${() => {
                        helpers.clearFilter(appliedFilter.id);
                        removeFilterDataLayerEvent(props, appliedFilter.id);
                      }} class="applied-filter">
                        <span class="applied-filter-label"
                        dangerouslySetInnerHTML=${{
                          __html:
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )+'<span class="price-applied-space">-</span>'+
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          ),
                        }} />
                        <button class="applied-filter-action-clear">
                          ${window.tagalysIcon.closeIcon(html)}
                        </button>
                      </li>
                    `;
                  }
                  return appliedFilter.items.map((filterItem) => {
                    return html`
                      <li
                        class="display-flex applied-filter"
                        onClick=${() => {
                          helpers.clearFilter(appliedFilter.id, filterItem.id);
                          removeFilterDataLayerEvent(
                            props,
                            appliedFilter.id,
                            filterItem
                          );
                        }}
                      >
                        <span class="filter__label applied-filter-label">
                          ${filterItem.label}
                        </span>
                        <button class="filter__label applied-filter-action-clear">
                          ${window.tagalysIcon.closeIcon(html)}
                        </button>
                      </li>
                    `;
                  });
                })}
              </ul>
            `;
    },
  },
  filter: {
    render: function (html, args) {
      return window.renderHelpers.filter(html, args);
    },
  },
  filterHeader: {
    render: function (html, args) {
      return window.renderHelpers.filterHeader(html, args);
    },
  },
  filterItems: {
    render: function (html, args) {
      var props = args.props;
      if (props.filter.type === "checkbox") {
        return html`
                <div class="filter__list filter-body filter-body-checkboxes ">
                  <${args.templates.filterCheckBoxes} filterId=${props.filter.id} filterItems=${props.filter.items} />
                </div>
              `;
      }
      return html`
              <div class="filter__list filter-body filter-body-range">
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterCheckBoxes: {
    render: function (html, args) {
      var props = args.props;
      return html`
              <ul class="filter-checkboxes">
                ${props.filterItems.map((filterItem) => {
                  return html`
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                  >
                  ${
                    filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : ""
                  }
                </${args.templates.checkboxFilterItem}>
              `;
                })}
              </ul>
            `;
    },
  },
  checkboxFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      const onFilterClick = (event) => {
        event.stopPropagation();
        if( document.querySelector(plp_selector) ) document.querySelector(plp_selector).setAttribute('aria-busy', true)
        if (props.filterItem.selected) {
          helpers.clearFilter(props.filterId, props.filterItem.id);
          removeFilterDataLayerEvent(props, props.filterId, props.filterItem);
        } else {
          helpers.applyFilter(props.filterId, props.filterItem.id);
          applyFilterDataLayerEvent(props);
        }
      };

      return html`
              <li class="filter-item" data-filter-item-id=${
                props.filterItem.id
              } onClick=${onFilterClick}>
                <span class="filter__type filter-checkbox-and-label">
                  <input name="filter_${props.filterItem.id}" class="checkbox" checked=${
                    props.filterItem.selected
                  } type="checkbox" />
                  <span class="filter-item-label-and-count">
                    <span class="filter-item-label">${
                      props.filterItem.label
                    }</span>
                    ${
                      props.showMatchingProductsCount
                        ? html`
                          <span class="filter-item-count">(${props.filterItem.count})</span>
                        `
                        : ""
                    }
                  </span>
                </span>
                ${props.children}
              </li>
            `;
    },
  },
  rangeSliderFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      let {priceLabel, minPriceValue, maxPriceValue, priceValueLeft, priceValueRight, priceValueLeftClass, priceValueRightClass} = window.renderHelpers.rangeSliderFilterItem(html, args)

      return html`
              <div class="range-slider filter-item">
                <span class="max-range-info">${priceLabel}</span>
                <div class="price-range-value" style="">
                  <span class="price-range__label--min-price ${priceValueLeftClass}" style="left: ${priceValueLeft};">
                    ${minPriceValue}
                  </span>
                  <span class="price-range__label--max-price ${priceValueRightClass}" style="right: ${priceValueRight};">
                    ${maxPriceValue}
                  </span>
                </div>
                <div ref=${props.sliderRef} />
                <div></div>
                <div class="price-range__input-group" style="display:none;">
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">$</span>
                    <input
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[0]}
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                      onfocus=${(this.value = "")}
                    />
                    <label style="display:none;">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.min,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  <span class="to">${
                    args.labels.filters.rangeFilterValueSeparator
                  }</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">$</span>
                    <input
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[1]}
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                    <label style="display:none;">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.max,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                </div>
              </div>
            `;
    },
  },
  sortOptionInFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var filterOptions = helpers.getTemplateOptions("filters");
      var appliedSortOption = helpers.getAppliedSortOption();
      var sortOptions = helpers.getSortOptions();

      let classes = ["filter"];
      let isCollapseOpen = false;
      if (filterOptions.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
        if (isCollapseOpen) {
          classes.push("is-expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");

      return html`
              <div data-filter-id="sort_options" class=${className}>
                <${args.templates.filterHeader} filterHeading=${
                  args.labels.sortOptions.sortBy
                  } filterId=${"sort_options"} />
                <div class="filter-body filter-body-checkboxes">
                  <ul class="filter-checkboxes">
                    ${sortOptions.map((sortOption) => {
                      const checked = sortOption.id === appliedSortOption.id;
                      return html`
                        <li
                          class="filter-item"
                          data-filter-item-id=${sortOption.id}
                          onClick=${() => {
                            helpers.applySortOption(sortOption.id);
                            clickSortOptionDataLayerEvent(helpers);
                          }}
                        >
                          <span class="filter-checkbox-and-label">
                            <input name="filter-item-${sortOption.id}" class="checkbox" checked=${checked} type="checkbox" />
                            <span class="filter-item-label-and-count">
                              <span class="filter-item-label">${
                                sortOption.label
                              }</span>
                            </span>
                          </span>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              </div>
            `;
    },
  },
  downArrow: {
    // eslint-disable-next-line no-unused-vars
    render: function (html, args) {
      return html`
              ${window.tagalysIcon.chevron.down(html)}
              ${window.tagalysIcon.chevron.up(html)}
            `;
    },
  },
  addToCartForm: {
    render: function (html, args) {
      const product = args.props.product;
      if( !product ) return html``;
      const variants = product.variants;
      let {isOnlyInStore, isOnlyInStoreClass} = window.renderHelpers.getTags(product.tags)

      return html`
              <form action="${
                window.plp_vars.cart_add_url
              }" method="post" enctype="multipart/form-data" class="form">
                <input type="hidden" name="quantity" value="1" />
                <${args.templates.variantSelect} product=${product} />
                <${args.templates.variantOption} product=${product} />
                ${
                  variants.length > 1
                    ? html`
                      <button class="btn--icon  product__add--show-variants" type="button" aria-label="${args.labels.products.quickAdd}">
                        ${window.tagalysIcon.addToCartVariants(html)}
                      </button>
                      <button
                        type="button"
                        class="product__add--mobile product__add--show-variants"
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.addToCartVariants(html)}
                      </button>
                    `
                    : html`
                      <button
                        class="btn--icon product__add"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.addToCart(html)}
                      </button>
                      <button
                        class="product__add--mobile"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.addToCart(html)}
                        ${window.tagalysIcon.checkmark(html)}
                      </button>
                    `
                }
              </form>
            `;
    },
  },
  variantOption: {
    render: function (html, args) {
      return html`
          <div class="product-card__variant-picker product-card__variant-picker--with-options">
          ${window.renderHelpers.variantOption.header(html, args)}
            <div role="list" class="product-card__variants">
              ${window.renderHelpers.variantOption.variantList(html, args)}
            </div>
            <div role="list" class="product-card__mobile-variants">
              ${window.renderHelpers.variantOption.variantListMobile(html, args)}
            </div>
          </div>
        `;
    },
  },
  variantSelect: {
    render: function (html, args) {
      return window.renderHelpers.variantSelect(html, args);
    },
  },
  productObj: {
    // Custom template to render variants
    render: function (html, args) {
      return window.renderHelpers.productObj(html, args)
    },
  },
  products: {
    render: function (html, args) {
      const props = args.props;
      const helpers = props.helpers;
      const products = helpers.getProducts();

      return html`
        ${products.map((product, index) =>
          product.images.length > 0
            ? html`
                <${args.templates.product} key=${index} product=${product} />
              `
            : ""
        )}
      `;
    },
    callbacks: {
      // eslint-disable-next-line no-unused-vars
      afterInitialRender: function (helpers) {
        window.renderHelpers.updateProductCards(".product-card");
      },
    },
  },
  sortOptions: {
    render: function (html, args) {
      return window.renderHelpers.sortOptions(html, args);
    },
  },

  productListHeader: {
    render: function (html, args) {
      return html`
              <${args.templates.infoAndActions} />
            `;
    },
  },
  noResults: {
    options: "",
    render: function (html, args) {
      return window.renderHelpers.noResults(html, args);
    },
  },
  infoAndActions: {
    render: function (html, args) {
      const props = args.props;
      const helpers = props.helpers;
      const filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="collection__tab collection__tab--sort display-flex align-center justify-center">

                ${
                  filterOptions.includeSortOptionsInFilters
                    ? ""
                    : html`<${args.templates.sortOptions} />`
                }
              </div>
            `;
    },
  },
  pagination: {
    render: function (html, args) {
      const props = args.props;
      const helpers = props.helpers;
      if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
        return html`<div class="text-center m-b-xs">
            <button class="load-next btn btn--primary" onclick=${
              props.helpers.loadNextPage
            }>
              ${
                helpers.isLoading()
                  ? args.labels.pagination.loading
                  : args.labels.pagination.loadNext
              }
            </button></div>
          `;
      }
      return null;
    },
  },
  loadPrevious: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      return html`<div class="previous-products-load-wrapper text-center m-b-xs">
        <button class="load-previous  btn btn--primary" onclick=${props.helpers.loadPreviousPage}>
          ${helpers.isLoading()
          ? args.labels.pagination.loading
          : args.labels.pagination.loadPrevious}
        </button>
        </div>
      `
    },
  },
  callbacks: {
    onSuccessfulAPICall: function (response, helpers) {
      window.renderHelpers.hideOpenedVariants();
      window.renderHelpers.checkStickyElements();
      return response;
    },
  },
};

function loadNativeCollection(){
  const plpContainer = document.querySelector('[data-widget="product-listing-page-container"]')
  if( plpContainer ) {
    //plpContainer.innerHTML = ''
    fetch(window.location.href + (window.location.href.includes('?') ? '&' : '?') + 'sections=native-collection-template-fallback')
      .then(response => response.json())
      .then(data => {
        if( data['native-collection-template-fallback'] ) {
          plpContainer.innerHTML = data['native-collection-template-fallback'];
        }
      })
  }
}

// helper for initializing the failover widget
TagalysCustomisationsCollection.initializeShopifyProductListingPage = function () {
  document.addEventListener('DOMContentLoaded', () => {
    return Tagalys.UIWidgets.ShopifyCollection.init(plp_selector, {
      params: plp_params,
      templates: shopifyProductListingPageTemplates,
      failover: function() {
        // 2nd failover - we can add native collection rendering
        loadNativeCollection();
      }
    });
  });
};
// helper for initializing the primary widget
TagalysCustomisationsCollection.initializeProductListingPage = function () {
  document.addEventListener('DOMContentLoaded', () => {
    Tagalys.UIWidgets.Collection.init(plp_selector, {
      params: plp_params,
      failover:
        TagalysCustomisationsCollection.initializeShopifyProductListingPage,
      templates: productListingPageTemplates,
      forceFailover: window.tagalysForceFailover,
    });
  });
};

function isAdVisibleOnCurrentDevice(selectedAd, mobileMaxWidth = 767) {
  const visibility = (selectedAd.visibility || '').trim();

  // Treat blank or "Both" as visible everywhere
  if (visibility === '' || visibility.toLowerCase() === 'both' || visibility.toLowerCase() === 'desktop and mobile') {
    return true;
  }

  // Decide current device using a mobile breakpoint
  const isMobile = window.matchMedia(`(max-width: ${mobileMaxWidth}px)`).matches;

  if (visibility.toLowerCase() === 'mobile only') {
    return isMobile;
  }

  if (visibility.toLowerCase() === 'desktop only') {
    return !isMobile;
  }

  // Unknown value: be conservative (don’t show)
  return false;
}

function collectionFiltersSticky() {
  if (window.innerWidth > 768) {
    setTimeout(function () {
      var headerHight = document.querySelector('#shopify-section-header').getBoundingClientRect().height;
      if (headerHight < 100) {
        headerHight = 114;
      }
      if (window.theme._sb_headerSection) {
        window.theme._sb_headerSection.update();
      }
      if (window.theme._sb_collectionSorting) {
        window.theme._sb_collectionSorting.update();
      }
      if (window.theme._sb_collectionFiltersBlock) {
        window.theme._sb_collectionFiltersBlock.update();
      }
      if (window.theme._sb_collectionFiltersActions) {
        window.theme._sb_collectionFiltersActions.update();
      }
    }, 1000);
  } else {
    setTimeout(function () {
      if (window.theme._sb_collectionFiltersActions) {
        window.theme._sb_collectionFiltersActions.update();
      }
    }, 1000);
  }
}

document.addEventListener("DOMContentLoaded", function () {

  var lastId = sessionStorage.getItem("tagalys_product_card_clicked");

  if(lastId){
    var productFindInterval = setInterval(function(){
      var productCard = document.querySelector(`.product-card[data-pid="${lastId}"]`);
      if (productCard) {
          productCard.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        sessionStorage.removeItem("tagalys_product_card_clicked");
        clearInterval(productFindInterval);
      }
    },100);
  }
});
